import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const mapearPagos = (pagos) => {
  return orderBy(pagos, ['id_moneda', 'colaborador', 'importe'], ['asc', 'asc', 'desc'])
    .map((item) => {
      item.busqueda = `${item.colaborador}|${item.banco_tarjeta}|${item.banco_cuenta}|${item.banco}|${item.id_empleado}|${item.importe}`
      item.$$seleccionado = !item.$$seleccionado
      return item
    })
}

export class NominasNominaDispersionPagosTransferenciasListaComponent {
  admin
  idProyecto
  idNomina
  idTipoPago
  idMetodoPago
  idMoneda
  idBanco
  metodoPago
  total
  moneda
  onChange
  onClose
  actualizando = false
  filtro = ''
  mostrar = 'clabe'
  seleccionados = []
  data = undefined

  constructor ($filter, NominasNominaDispersionPagosTransferencias) {
    this.NominasNominaDispersionPagosTransferencias = NominasNominaDispersionPagosTransferencias
  }

  $onInit () {
    this.promise = this.NominasNominaDispersionPagosTransferencias.get(this.idProyecto, this.idNomina, this.idTipoPago, this.idMoneda, this.idBanco)
      .then(({data}) => {
        this.data = orderBy(data, ['id_moneda', 'colaborador', 'importe'], ['asc', 'asc', 'desc'])
          .map((item) => {
            item.busqueda = `${item.colaborador}|${item.banco_tarjeta}|${item.banco_cuenta}|${item.banco}|${item.id_empleado}|${item.importe}`
            item.$$seleccionado = false
            return item
          })

        this.totalizar()
        this.filtrar()
      })
  }

  dividirPagos (data) {
    data.forEach((item) => {
      const pago = this.data.find(element => element.id === item.id)
      pago.importe = item.importe
      item.resultados.forEach((pagos) => (this.data.push(Object.assign({}, pago, pagos))))
    })

    this.data = orderBy(this.data, ['id_moneda', 'colaborador', 'importe'], ['asc', 'asc', 'desc'])

    this.totalizar()
    this.seleccionar()
    this.filtrar()
  }

  actualizar (data) {
    if (data) {
      data.forEach((item) => {
        let seleccionado = this.data.find((seleccionado) => seleccionado.id === item.id)
        if (seleccionado) Object.assign(seleccionado, item)
      })
    }

    this.filtrar()
    this.seleccionar()

    this.onChange({$event: {data: this.data}})
  }

  cerrar () {
    this.onChange({$event: {data: this.data}})
    this.onClose()
  }

  filtrar () {
    this.resultados = this.data.filter((item) => item.busqueda.contains(this.filtro))

    this.totalizarSeleccionados()
  }

  seleccionar () {
    this.seleccionados = this.data.filter((item) => item.$$seleccionado)
  }

  seleccionarItem (item) {
    item.$$seleccionado = !item.$$seleccionado

    this.seleccionar()
    this.totalizarSeleccionados()
  }

  seleccionarItems (todos) {
    this.resultados.filter((item) => (this.admin ? true : !item.pendiente))
      .forEach((item) => (item.$$seleccionado = todos))

    this.seleccionar()
    this.totalizarSeleccionados()
  }

  totalizar () {
    if (!Array.isArray(this.data)) return
    this.total = this.data.reduce((total, item) => +(total + (item.importe / item.tipo_cambio)).toFixed(2), 0)
  }

  totalizarSeleccionados () {
    this.todosSeleccionados = this.resultados.filter((item) => (this.admin ? true : !item.pendiente))
      .every((item) => item.$$seleccionado)
  }
}

module.component('nominasNominaDispersionPagosTransferenciasLista', {
  controller: NominasNominaDispersionPagosTransferenciasListaComponent,
  template,
  bindings: {
    admin: '<',
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    idMetodoPago: '<',
    idMoneda: '<',
    idBanco: '<',
    metodoPago: '<',
    total: '<',
    moneda: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/transferencias/lista/component.js